export default __webpack_public_path__ + "static/media/ceo-portrait.00cf0cd6.jpg";